import axios from "axios";
import { urlAzure } from "../config";

export async function getUsuarios(setValue, token) {
    var config = {
      method: 'get',
      url: `${urlAzure}api/Usuario/list`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    try {
      const response = await axios(config);
      const dataWithIds = response.data.map((item) => ({ ...item, id: item.id_usuario }));
      setValue(dataWithIds.sort((a, b) => b.id_usuario - a.id_usuario));
    } catch (error) {
      console.error(error);
    }
}

export async function getAreas(setValue, token) {
    var config = {
      method: 'get',
      url: `${urlAzure}api/Usuario/areas`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    try {
      const response = await axios(config);
      setValue(response.data);
    } catch (error) {
      console.error(error);
    }
}

export async function createUsuario(datos, token) {
    var config = {
      method: 'post',
      url: `${urlAzure}api/Usuario/create`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: JSON.stringify(datos)
    };
    const response = await axios(config);
    return response.data;
}

export async function updateUsuario(datos, token) {
    var config = {
      method: 'post',
      url: `${urlAzure}api/Usuario/update`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: JSON.stringify(datos)
    };
    const response = await axios(config);
    return response.data;
}

export async function deleteUsuario(id_usuario, token) {
    var config = {
      method: 'post',
      url: `${urlAzure}api/Usuario/delete/${id_usuario}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    const response = await axios(config);
    return response.data;
}

export async function getUsuariosTodos(setValue, token) {
    var config = {
      method: 'get',
      url: `${urlAzure}api/Usuario/listTodos`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    try {
      const response = await axios(config);
      setValue(response.data);
    } catch (error) {
      console.error(error);
    }
}

export async function getPermisosUsuario(id_usuario, setValue, token) {
    var config = {
      method: 'get',
      url: `${urlAzure}api/Usuario/permisos/${id_usuario}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    try {
      const response = await axios(config);
      setValue(response.data);
    } catch (error) {
      console.error(error);
    }
}

export async function guardarPermisos(id_usuario, id_submodulos, token) {
    var config = {
      method: 'post',
      url: `${urlAzure}api/Usuario/permisos/guardar`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: JSON.stringify({ id_usuario: id_usuario, id_submodulos: id_submodulos })
    };
    const response = await axios(config);
    return response.data;
}

export async function copiarPermisos(id_usuario_origen, id_usuario_destino, token) {
    var config = {
      method: 'post',
      url: `${urlAzure}api/Usuario/permisos/copiar`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: JSON.stringify({ id_usuario_origen: id_usuario_origen, id_usuario_destino: id_usuario_destino })
    };
    const response = await axios(config);
    return response.data;
}
